<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <myExportExcel
          :excelTitleList="titleList"
          :idsList="exportIdsList"
          :url="OUTSOURCING_EXPORT_URL.PRODUCT_ORDER"
          :filter="searchData"
          :excelName="'产品委外订单'"
        />
        <printViewBtn
          :changeList="changeList"
          :modules="OUTSOURCING_PRINT_MODULES.PRODUCT_ORDER"
          :printFun="outsourcingDoc_view"
          :groupPrintFun="outsourcingDoc_vagueOutsourcingDocListByIds"
        />
      </div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    />
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'outsourcingDocId'"
      :keyData="keyData"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      :dialogStatus="1"
      ref="myTable"
    />
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    />
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    />
  </div>
</template>
<script>
import { outsourcingDoc_vagueList, outsourcingDoc_view, outsourcingDoc_vagueOutsourcingDocListByIds } from '@/api/myController/outsourcing'
import { OUTSOURCING_PRINT_MODULES } from '@/utils/outsourcingPrint'
import {
  OUTSOURCING_EXPORT_URL,
  buildExportIdsList,
} from '@/utils/outsourcingExport'
import {
  PORTAL_ORDER_STATUS,
  PORTAL_ORDER_STATUS_OPTIONS,
  buildPortalStatusFilter,
  canReceivePortalOrder,
  canShipPortalOrder,
  resolvePortalOrderStatus
} from '@/utils/outsourcingOrderStatus'

export default {
  name: 'outsourcingProduct_order',
  data() {
    return {
      htmlDataDialogState: {
        show1: false,
        show2: false
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 47,
      OUTSOURCING_PRINT_MODULES,
      OUTSOURCING_EXPORT_URL,
      outsourcingDoc_view,
      outsourcingDoc_vagueOutsourcingDocListByIds,
      topTitle: '产品委外订单',
      searchData: {
        portalOrderStatus: '',
        outsourcingDocNumber: '',
        baseMaterialNumber: '',
        baseMaterialName: '',
        valueOutsourcingDeliveryDateAll: null,
        searchString: ''
      },
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      orderParam: {
        asc: false,
        dateAggregateBy: '',
        fieldName: 'createTime'
      },
      operationTitleData: [
        { name: '委外单号', value: 'outsourcingDocNumber', type: 'text' },
        { name: '产品编号', value: 'baseMaterialNumber', type: 'text' },
        { name: '产品名称', value: 'baseMaterialName', type: 'text' },
        { name: '交货日期', value: 'valueOutsourcingDeliveryDateAll', type: 'date' }
      ],
      titleOperationTitleData: [
        {
          name: '订单状态',
          value: 'portalOrderStatus',
          type: 'buttonList',
          btnList: [
            { name: '全部', value: '' },
            { name: '待收料', value: PORTAL_ORDER_STATUS.PENDING_RECEIVE },
            { name: '加工中', value: PORTAL_ORDER_STATUS.PROCESSING },
            { name: '待发货', value: PORTAL_ORDER_STATUS.PENDING_SHIP },
            { name: '已完成', value: PORTAL_ORDER_STATUS.COMPLETED }
          ]
        },
        { name: '', type: 'line' },

        { name: '综合查询', type: 'text', value: 'searchString' },
        { name: '搜索', type: 'button' },
        { name: '重置', type: 'button' }
      ],
      listLoading: false,
      columnType: 'columnAll',
      tableBtnList: ['详情', '收料', '出货', '库存'],
      list: [],
      changeList: [],
      keyData: ['outsourcingDocId'],
      titleList: [
        {
          id: 1,
          name: '产品图片',
          value: 'baseImgUrl',
          isShow: true,
          dataType: 'image',
          canEdit: false,
          width: 60,
          sort: 10
        },
        {
          id: 2,
          name: '委外单编号',
          value: 'outsourcingDocNumber',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 140,
          color: '#409eff',
          sortable: true,
          sort: 20
        },
        {
          id: 2,
          name: '全局搜索码',
          value: 'globalSearchNumber',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 140,
          sortable: true,
          sort: 20
        },
        {
          id: 3,
          name: '产品编号',
          value: 'baseMaterialNumber',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 120,
          sort: 30
        },
        {
          id: 4,
          name: '产品名称',
          value: 'baseMaterialName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150,
          sort: 40
        },
        {
          id: 5,
          name: '规格型号',
          value: 'specifications',
          isShow: true,
          dataType: 'textList',
          canEdit: false,
          width: 160,
          sort: 50
        },
        {
          id: 6,
          name: '订单数量',
          value: 'baseOutsourcingQuantity',
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 90,
          sort: 60
        },
        {
          id: 7,
          name: '已收料数量',
          value: 'valueRequisitionQuantity',
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 100,
          sort: 70
        },
        {
          id: 8,
          name: '已出货数量',
          value: 'valueInwarehouseQuantity',
          isShow: true,
          dataType: 'number',
          canEdit: false,
          width: 100,
          sort: 80
        },
        {
          id: 9,
          name: '交货日期',
          value: 'valueOutsourcingDeliveryDate',
          isShow: true,
          dataType: 'dateTime',
          canEdit: false,
          width: 110,
          sortable: true,
          sort: 90
        },
        {
          id: 10,
          name: '订单状态',
          value: 'portalOrderStatus',
          isShow: true,
          dataType: 'customSelect',
          selectOptionList: PORTAL_ORDER_STATUS_OPTIONS,
          canEdit: false,
          width: 90,
          sort: 100
        },
        {
          id: 11,
          name: '负责人',
          value: 'baseOutsourcingChargemanName',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 90,
          sort: 110
        },
        {
          id: 12,
          name: '订单附件',
          value: 'valueFileList',
          isShow: true,
          dataType: 'fileList',
          canEdit: false,
          width: 80,
          sort: 120
        },
        {
          id: 13,
          name: '备注',
          value: 'remark',
          isShow: true,
          dataType: 'textarea',
          canEdit: false,
          width: 160,
          sort: 130
        },
        {
          id: 14,
          name: '创建时间',
          value: 'createTime',
          isShow: true,
          dataType: 'text',
          canEdit: false,
          width: 150,
          sort: 140
        }
      ]
    }
  },
  computed: {
    exportIdsList() {
      return buildExportIdsList(this.changeList, 'outsourcingDocId')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    buildFilter() {
      const filter = {}
      const data = this.searchData || {}
      if (data.searchString) {
        filter.searchString = data.searchString
      }
      if (data.outsourcingDocNumber) {
        filter.outsourcingDocNumber = data.outsourcingDocNumber
      }
      if (data.baseMaterialNumber) {
        filter.baseMaterialNumber = data.baseMaterialNumber
      }
      if (data.baseMaterialName) {
        filter.baseMaterialName = data.baseMaterialName
      }
      const deliveryRange = data.valueOutsourcingDeliveryDateAll
      if (deliveryRange && deliveryRange.length === 2) {
        filter.valueOutsourcingDeliveryDateStart = deliveryRange[0]
        filter.valueOutsourcingDeliveryDateEnd = `${deliveryRange[1]} 23:59:59`
      }
      Object.assign(filter, buildPortalStatusFilter(data.portalOrderStatus))
      return filter
    },
    normalizeListRow(item) {
      try {
        item.specifications = JSON.parse(item.baseMaterialSpecDesc)
      } catch (error) {
        item.specifications = []
      }
      item.portalOrderStatus = resolvePortalOrderStatus(item)
      return item
    },
    getList() {
      this.listLoading = true
      outsourcingDoc_vagueList({
        orderParam: [this.orderParam],
        outsourcingDocFilter: this.buildFilter(),
        pageParam: this.listQuery
      }).then((res) => {
        const pageData = res.data.data || {}
        const dataList = (pageData.dataList || []).map((item) => this.normalizeListRow(item))
        this.list = dataList
        this.listQuery.total = pageData.totalCount || 0
        this.listLoading = false
        this.$refs.myOperate?.dragSortShow()
      }).catch(() => {
        this.list = []
        this.listQuery.total = 0
        this.listLoading = false
      })
    },
    titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case '搜索':
          this.listQuery.pageNum = 1
          this.getList()
          break
        case '重置':
          this.searchData = {
            portalOrderStatus: '',
            outsourcingDocNumber: '',
            baseMaterialNumber: '',
            baseMaterialName: '',
            valueOutsourcingDeliveryDateAll: null,
            searchString: ''
          }
          this.listQuery.pageNum = 1
          this.getList()
          break
        case '全部':
        case '待收料':
        case '加工中':
        case '待发货':
        case '已完成':
          if (titleData) {
            this.searchData = { ...this.searchData, ...titleData }
          }
          this.listQuery.pageNum = 1
          this.getList()
          break
        default:
          break
      }
    },
    operationBtnClick(item) {
      this.titleOperationBtnClick(item)
    },
    btnClick(row, item) {
      switch (item) {
        case '详情':
          this.openDetail(row)
          break
        case '收料':
          if (!canReceivePortalOrder(row)) {
            this.$message.warning('该订单已完成，无需收料')
            return
          }
          this.$router.push({
            name: 'outsourcingProduct_materials',
            query: {
              outsourcingDocNumber: row.outsourcingDocNumber,
              action: 'receive'
            }
          })
          break
        case '出货':
          if (row.portalOrderStatus === PORTAL_ORDER_STATUS.COMPLETED) {
            this.$message.warning('该订单已完成，无需出货')
            return
          }
          if (!canShipPortalOrder(row)) {
            this.$message.warning('本厂尚未发料，暂不能出货')
            return
          }
          this.routeQuery = row
          this.routeType = 1
          this.homeIndex = 50
          this.htmlDataDialogState.show1 = true
          break
        case '库存':
          this.$router.push({
            name: 'outsourcingProduct_warehouse',
            query: {
              bizDocKind: 0,
              outsourcingDocId: row.outsourcingDocId || row.baseOutsourcingDocId,
              outsourcingDocNumber: row.outsourcingDocNumber,
            },
          })
          break
        default:
          break
      }
    },
    openDetail(row) {
      this.routeQuery = row
      this.homeIndex = 47
      this.htmlDataDialogState.show2 = true
    },
    cellClickEvent(row, column) {
      if (column.field === 'outsourcingDocNumber') {
        this.openDetail(row)
      }
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false
      this.htmlDataDialogState.show2 = false
      this.routeType = 0
      this.routeQuery = {}
      this.homeIndex = 47
      this.getList()
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth
        }
      })
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList
    },
    isShowClick(titleList) {
      this.titleList = titleList
    },
    widthClick(titleList) {
      this.titleList = titleList
    },
    resetClick(titleList) {
      this.titleList = titleList
    },
    selectChangeEvent(val) {
      this.changeList = val.records
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title--font {
  text-align: left;
  padding: 10px 0;
  font-size: 26px;
  font-weight: bold;
  color: #1476C3;
}

.title--button {
  position: absolute;
  right: 0;
  margin-top: 0.7%;
}

::v-deep .operation {
  margin-bottom: 10px;
}

::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination span:not([class*='suffix']),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  box-sizing: border-box;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}

::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}

::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}

::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
</style>
